import { render, staticRenderFns } from "./editVendor.vue?vue&type=template&id=a40a9a96&"
import script from "./editVendor.vue?vue&type=script&lang=js&"
export * from "./editVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports